import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import routes from "../../../pages/routes";
import { getLocalUserProfile } from "../../../services/auth.service";
import courseEnrolmentService from "../../../services/course-enrolment.service";
import programsService from "../../../services/program_service/programs.service";

export const CourseEnrolmentModal: React.FC<any> = ({
  isOpen,
  onClosed,
  isEnrol = false,
  data,
  reload,
}: {
  isEnrol: boolean;
  isOpen: any;
  onClosed: any;
  data: IAvailableCourse;
  reload: any;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const [course_available, setCourseAvailable] = useState<any>();

  const [programDiscipline, setProgramDiscipline] = useState([]);
  const [programSpecialization, setProgramSpecialization] = useState([]);
  const [userId, setUserId] = useState<number>();
  const navigate = useNavigate()
  useEffect(() => {
  
    if (data) setCourseAvailable(data);
    console.log(data, "course")
    const user = getLocalUserProfile();
    if (user) setUserId(user.id)
    programsService.getDisciplines().then(
      (res) => {
        setProgramDiscipline(res.data);
      }
    )
    programsService.getSpecializations().then(
      (res) => {
        setProgramSpecialization(res.data);
      }
    )

  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.center1) {
        errors.center1 = "Please select a center";
      }
      if (!values.center2) {
        errors.center2 = "Please select a center";
      }
      if (!values.programDisciplineId) {
        errors.programDisciplineId = "Please select a program discipline";
      }
      if (!values.programSpecializationId) {
        errors.programSpecializationId = "Please select a program specialization";
      }
      if (values.center1.toString() == values.center2.toString()) {
        errors.center2 = "Please select another center!";
      }
      return errors;
    },
    initialValues: {
      center1: "",
      center2: "",
      programDisciplineId: "",
      programSpecializationId: "",
    },
    onSubmit: async (values) => {
      try {
        const enroltraineedto: any = {
          centre_1_id: values.center1,
          centre_2_id: values.center2,
          course_session_id: course_available?.session_id,
          course_term_id: course_available?.term_id,
          force_enrol: false,
          trainee_id: userId,
          program_discipline_id: values.programDisciplineId,
          program_specialization_id: values.programSpecializationId
        };
        const enroltrainee = await courseEnrolmentService.applyForProgram(enroltraineedto, course_available?.course.uuid);
        if (enroltrainee) {
          toast({
            title: "Course Enrolment",
            description: "Course Enroled Successfully",
            status: "success",
            duration: 2000,
            onCloseComplete: () => closeModal(),
          });
          reload();
        }
      } catch (error: any) {
        toast({
          title: "Course Enrolment",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });
  const closeModal = () => {
    sessionStorage.removeItem('available_course')
    onClosed()
    navigate(routes.successfulEnrolment)
  }

  return (
    <>
      <Modal
        isOpen={isOpen && isEnrol}
        onClose={onClosed}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={4}>
          <ModalHeader>
            {
              <Text
                fontSize="21px"
                fontWeight="700"
                pb={1}
                textTransform="none"
                pl={3}
                color="#2B2B2B"
              >
                Course Enrolment
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={6}>
            <Box mt={2}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mt={4}
                  isInvalid={
                    formik.errors.center1 && formik.touched.center1
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                    Preferred Training Center:
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select center"
                    value={formik.values.center1}
                    name="center1"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {course_available &&
                      course_available.centers &&
                      course_available.centers.map((each: any, index: number) => (
                        <option key={index} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                  </Select>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.center1}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={4}
                  isInvalid={
                    formik.errors.center2 && formik.touched.center2
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                    Second Preferred Training Center{" "}
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select center"
                    value={formik.values.center2}
                    name="center2"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {course_available &&
                      course_available.centers &&
                      course_available.centers.map((each:any, index:any) => (
                        <option key={index} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                  </Select>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.center2}{" "}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={4}
                  isInvalid={
                    formik.errors.programSpecializationId && formik.touched.programSpecializationId
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                    Preferred Specialization:
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select program specialization"
                    value={formik.values.programSpecializationId}
                    name="programSpecializationId"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {
                      programSpecialization.map((each: any, index: number) => (
                        <option key={index} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))
                    }

                  </Select>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.programSpecializationId}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={4}
                  isInvalid={
                    formik.errors.programDisciplineId && formik.touched.programDisciplineId
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                    Preferred Program Discipline:
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select program discilpline"
                    value={formik.values.programDisciplineId}
                    name="programDisciplineId"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {
                      programDiscipline.map((each: any, index: number) => (
                        <option key={index} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))
                    }

                  </Select>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.programDisciplineId}
                  </FormErrorMessage>
                </FormControl>

                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      size="sm"
                      px={6}
                      fontSize={12}
                      ref={cancelRef}
                      onClick={() => onClosed()}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      {" "}
                      Enrol
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};